// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { zipCodeStyles } from "@west/App/Widgets/Header/ZipCode";
import Edit from "@west/XDL/Icons/Edit";
import { color, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

zipCodeStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 2px;

        ${xScreen("lt", "sm")} {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 4px;
            padding: 8px 16px;
        }
    `,
};

zipCodeStyles.title = {
    size: 12,
    weight: "bold",
    css: css`
        line-height: 14px;
        white-space: nowrap;
    `,
};

zipCodeStyles.valueContainer = {
    css: css`
        display: flex;
        align-items: center;
        gap: 4px;
    `,
};

zipCodeStyles.value = {
    size: 12,
    color: "text.link",
    weight: "bold",
    css: css`
        line-height: 14px;
        white-space: nowrap;
    `,
};

zipCodeStyles.editIconClickable = {
    css: css`
        padding: 5px 8px; // we need it to make UX experience better on mobile
    `,
};

zipCodeStyles.editIcon = {
    size: 10,
    src: Edit,
    color: "common.ui8",
    css: css`
        opacity: 0.5;
        cursor: pointer;
        &:hover {
            opacity: 1;
            color: ${color("common.ui9")};
        }
    `,
};

zipCodeStyles.modal = {
    size: 400,
    cssOverrides: {
        modalBody: css`
            ${xScreen("lt", "md")} {
                max-width: 400px;
            }
        `,
    },
};
